export interface IDestinationsStoreState {
  isLoading: boolean;
  data: IDestinationsData;
}

export interface IDestinationsData {
  trending_destinations: IDestinationsListInfo;
  popular_tags: {[key: string]: Array<string>};
  meta_config: {
    entities_data: {
      [key: string]: {
        lid: string;
        nh: string;
        asp: string;
        h_text: string;
        sub_text: string;
        img: Array<{
          fs_webp: string;
          format: string;
          url: string;
          align: string;
          base_url: string;
          srp_webp: string;
          th_webp: string;
        }>;
      };
    };
    template: string;
  };
  tags_data: {tags: {[key: string]: {n: string}}};
  popular_destinations: IDestinationsListInfo;
}

export interface IDestinationsListInfo {
  text: string;
  id_list: Array<string>;
}

export const UPDATE_DESTINATIONS = 'UPDATE_DESTINATIONS';
export const TOGGLE_LOADING_DESTINATIONS = 'TOGGLE_LOADING_DESTINATIONS';

export interface IUpdateDestinations {
  type: typeof UPDATE_DESTINATIONS;
  actionData: IDestinationsStoreState['data'];
}

export interface IToggleLoadingDestinations {
  type: typeof TOGGLE_LOADING_DESTINATIONS;
  actionData: IDestinationsStoreState['isLoading'];
}

export type DestinationsActionTypes = IToggleLoadingDestinations | IUpdateDestinations;
